import { Phone } from "lucide-react";
import { CLINIC } from "@/data/content";

export default function StickyPhoneBar() {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-white/90 backdrop-blur-md border-t border-slate-200" data-testid="sticky-phone-bar">
      <a href={CLINIC.phoneRaw} data-testid="sticky-phone-call-button"
        className="flex items-center justify-center gap-3 w-full bg-[#A6823B] text-white font-semibold py-3.5 rounded-full shadow-lg shadow-[#A6823B]/30 active:scale-[0.98] transition-transform">
        <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center pulse-ring">
          <Phone className="w-4 h-4" />
        </span>
        Sună pentru programare · {CLINIC.phone}
      </a>
    </div>
  );
}
